module.exports = "<li class=\"gw-bullet-list\" gw-partial=\"Item\"></li>\n"